var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499333 5.04066C0.366 5.04066 0.24 5.09266 0.146 5.18733C-0.0486667 5.382 -0.0486667 5.69933 0.146 5.89466L7.29267 13.04C7.48133 13.2293 7.732 13.3333 7.99867 13.3333C8.266 13.3333 8.51667 13.2293 8.70533 13.0413L15.8527 5.89466C16.0473 5.69999 16.0473 5.38266 15.8527 5.18733C15.758 5.09266 15.6327 5.04066 15.4993 5.04066C15.366 5.04066 15.24 5.09266 15.146 5.18733L7.99933 12.3333L0.852667 5.18733C0.758667 5.09266 0.632667 5.04066 0.499333 5.04066Z",
    stroke: "#3C4D6A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalDropDown);
export default __webpack_public_path__ + "static/media/modal-drop-down.62800fd1219dd8bce09f4a989392cef4.svg";
export { ForwardRef as ReactComponent };